/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  UnproxiedMcpServerUsageBucket,
  UnproxiedMcpServerUsageBucket$inboundSchema,
} from "./unproxiedmcpserverusagebucket.js";

/**
 * Result of a Shadow-MCP-backed usage lookup for an unproxied MCP server
 */
export type GetUnproxiedMcpServerUsageResult = {
  buckets: Array<UnproxiedMcpServerUsageBucket>;
};

/** @internal */
export const GetUnproxiedMcpServerUsageResult$inboundSchema: z.ZodMiniType<
  GetUnproxiedMcpServerUsageResult,
  unknown
> = z.object({
  buckets: z.array(UnproxiedMcpServerUsageBucket$inboundSchema),
});

export function getUnproxiedMcpServerUsageResultFromJSON(
  jsonString: string,
): SafeParseResult<GetUnproxiedMcpServerUsageResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetUnproxiedMcpServerUsageResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetUnproxiedMcpServerUsageResult' from JSON`,
  );
}
